<template>
  <div class="page-wrap">

    <!-- ── Page Header ── -->
    <div class="page-header">
      <div class="page-header__left">
        <button class="btn-back" @click="$router.back()">
          <i class="fa fa-arrow-left"></i>
        </button>
        <div>
          <h1 class="page-title">Purchase History</h1>
          <span class="page-subtitle">User #{{ id }}</span>
        </div>
      </div>
    </div>

    <!-- ── Table ── -->
    <div class="table-panel" v-if="loaded">
      <div class="table-responsive-wrap">
        <table class="dd-table">
          <thead>
          <tr>
            <th>Type</th>
            <th>Title</th>
            <th>Created At</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(item, index) in items"
              :key="index"
              class="dd-table__row"
              @click.prevent="$router.push(`/carts/${item.cart_id}`)"
          >
            <td v-html="getTypeBadge(item.type)"></td>
            <td><span class="item-title">{{ item.title }}</span></td>
            <td class="date-cell">{{ formatDate(item.created_at) || '—' }}</td>
          </tr>

          <tr v-if="items && items.length === 0">
            <td colspan="3" class="empty-state">
              <i class="fa fa-shopping-bag"></i>
              <div>No purchases found</div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Loading -->
    <div class="mt-5 pt-5">
      <loading v-if="!loaded"></loading>
    </div>

  </div>
</template>

<script>
import { config } from "../helpers";

export default {
  name: "UserPurchases",
  data() {
    return {
      url: "",
      id: this.$route.params.id,
      items: [],
      loaded: false,
    };
  },

  mounted() {
    this.url = config("BACKEND_ROOT") + "/admin/users";
    this.loadData();
  },

  methods: {
    loadData() {
      axios.get(`${this.url}/${this.id}/purchases`).then((r) => {
        this.items  = r.data.data;
        this.loaded = true;
      });
    },

    formatDate(date) {
      if (!date) return null;
      const d = new Date(date);
      return `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()} ${d.getHours()}:${String(d.getMinutes()).padStart(2,"0")}`;
    },

    getTypeBadge(type) {
      if (type === "Experience") {
        return '<span class="status-badge status-badge--green">Experience</span>';
      }
      return '<span class="status-badge status-badge--blue">Gift</span>';
    },
  },
};
</script>

<style scoped>
.page-wrap  { display: flex; flex-direction: column; gap: 16px; }

.page-header { display: flex; align-items: flex-start; gap: 12px; }
.page-header__left { display: flex; align-items: flex-start; gap: 12px; }
.btn-back { width: 34px; height: 34px; margin-top: 4px; background: var(--bg-hover); border: 1px solid var(--border); border-radius: 8px; color: var(--text-2); cursor: pointer; display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: border-color .15s, color .15s; }
.btn-back:hover { border-color: var(--accent); color: var(--accent); }
.page-title   { font-size: 20px; font-weight: 500; color: var(--text-1); margin: 0 0 2px; }
.page-subtitle { font-size: 12px; color: var(--text-3); }

.table-panel { background: var(--bg-panel); border: 1px solid var(--border); border-radius: 12px; overflow: hidden; }
.table-responsive-wrap { overflow-x: auto; }
.dd-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.dd-table thead tr { border-bottom: 1px solid var(--border); }
.dd-table th { padding: 10px 14px; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .5px; color: var(--text-3); text-align: left; white-space: nowrap; }
.dd-table td { padding: 12px 14px; color: var(--text-2); border-bottom: 1px solid var(--border); vertical-align: middle; }
.dd-table__row { cursor: pointer; transition: background .12s; }
.dd-table__row:hover td { background: var(--bg-hover); }
.dd-table tr:last-child td { border-bottom: none; }

.item-title { font-weight: 500; color: var(--text-1); }
.date-cell  { font-size: 12px; color: var(--text-3); white-space: nowrap; }

.empty-state { text-align: center; padding: 3rem 1rem !important; color: var(--text-3); }
.empty-state i { font-size: 32px; display: block; margin-bottom: 8px; }
</style>
